const ArchiveJobs = ({generic, unit_filters, office_filters, list}) => {
  const normalizedData = {
    generic, unit_filters, office_filters, list
  }

  return normalizedData
}

export default ArchiveJobs
